import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

const _Msg = React.memo((pz: ht.msgCz) => {

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.msgAbtz[_abtType] ? ica.msgAbtz[_abtType]() : {};

  return (
    cr.c(BoxC.N, {
      key: 'Msg.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      oClds: pz.cz.ls.filter((_dz: ht.dz) => hf.f(_dz)).map( (_dz: ht.dz, _idx: ht.n) => {
        return (
          cr.c(BoxC.N, {
            key: _idx,
            boxStlz: {
              ... _abtz.lz?.boxStlz,
              ... _dz.boxStlz
            },
            oClds: [
              _dz.mkrCz ?
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  ... _dz.mkrCz?.textz,
                  stlz: {
                    ... _abtz.lz?.mkrCz?.textz?.stlz,
                    ... _dz.mkrCz?.textz?.stlz
                  },
                  ptyz: {
                    ... _abtz.lz?.mkrCz?.textz?.ptyz,
                    ... _dz.mkrCz?.textz?.ptyz
                  }
                },
                boxStlz: {
                  ... _abtz.lz?.mkrCz?.boxStlz,
                  ... _dz.mkrCz?.boxStlz
                },
              })
              : null,
              _dz.msgCz ?
              cr.c(TextC.N, {
                key: -20,
                textz: {
                  ... _dz.msgCz?.textz,
                  stlz: {
                    ... _abtz.lz?.msgCz?.textz?.stlz,
                    ... _dz.msgCz?.textz?.stlz
                  },
                  ptyz: {
                    ... _abtz.lz?.msgCz?.textz?.ptyz,
                    ... _dz.msgCz?.textz?.ptyz
                  }
                },
                boxStlz: {
                  ... _abtz.lz?.msgCz?.boxStlz,
                  ... _dz.msgCz?.boxStlz
                },
              })
              : null,
            ]
          })
        )
      })
    })
  )
});
export const N = _Msg;
